import OurStoryFounders from "../components/about/OurStoryFounders";
import OurMissionValues from "../components/about/OurMissionValues";

import MeetOurTeam from "../components/about/MeetOurTeam";
import PrincipalMessage  from "../components/about/PrincipalMessage";

const AboutUs = () => {
  return (
    <div>
      <OurStoryFounders />
      <OurMissionValues/>
      <MeetOurTeam/>
      <PrincipalMessage />
    </div>
  );
};

export default AboutUs;
